const selectTableSplit = {
  tables: {
    searchPlaceholder: 'Search',
  },
};

export default selectTableSplit;
